import * as React from "react";
import { Link } from "gatsby";
// import { StaticImage } from "gatsby-plugin-image";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import NewsHeader from "../../components/NewsHeader";
import SleepyNewsAnchor from "../../components/SleepyNewsAnchor";

const NewsPage = () => (
	<Layout>
		<Seo title="May 2025" />
		<NewsHeader />
		<h2>May 2025</h2>

		<h3 className="blogdate">
			Friday, May 2, 2025
		</h3>

		<h4 className="blogitemtitle">
			<SleepyNewsAnchor num="1">I'm giving AirGigs a go</SleepyNewsAnchor>
		</h4>
		<div className="blogitembody">
			<p>
				I decided in January to put up a profile and some services on the AirGigs platform and I've been surprised ever since—I've been keeping busy there!
				Granted, I've had my prices set to about as low as they can be to incentivize some initial work and build up some reviews.
				I plan to soon investigate where my pricing really should be and update my gigs.
				I have three at the moment: recording guitar, creating/recording vocal arrangements, and mixing/mastering a track.
				All three of them have so far been successful, I'm pleased to say.
				If you know anyone who might like to engage me in one of these services (or something else I can consider), please send them my way!
			</p>

			<ul className="p">
				<li>
					<a href="//www.airgigs.com/user/jessejr">Jesse on AirGigs</a> (click on <span className="bold">Show More</span> under Services)
				</li>
			</ul>

			<p>
				I also got very candid for the camera and explained how I've made a living the past two decades;
				the video is up on <a href="//www.patreon.com/posts/127908940">my Patreon page</a>,
				which I intend to always keep (membership) as payment optional.
			</p>

			<p>
				My <span className="bold">Time for a Song</span> video series continues with <span className="italic">On the Cliffs Outside of Broome</span>.
				This is one of the better performances I captured during a time period in which I was trying out lozenges for my voice.
				The problem is: I was trying to sing with the lozenges in my mouth 🤦‍♂️!
				This particular performance isn't too bad in that regard.
				I later resolved to only have lozenges (one or two) before it's time to sing.
			</p>

			<iframe
			className="p"
			width="94%"
			height="315"
			style={{maxWidth: 560}}
			src="https://www.youtube-nocookie.com/embed/DZKDh3z51CM"
			title="YouTube video player"
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen />

			<p>
				Lastly, I do weekly practice sessions live on YouTube to keep my repertoire alive.
				Feel free to drop in for a small hang sometime!
				Usually the event is created/bookmarked on a Monday and I go live on Wednesday—keep an eye on <a href="//youtube.com/@jesserivest/streams">my YouTube</a>.
			</p>

			<p>
				Cheers!
			</p>

			<div className="main--centerwrapper p">
			</div>

		</div>

		<p>
		<Link to="/news/">Go back to the news index page</Link>
		</p>
	</Layout>
);

export default NewsPage;
